if (!customElements.get('product-listing')) {
  const plpLoader = `
    <div class="sp-flex sp-flex-col sp-gap-4">
        <div class="sp-bg-gray-100 sp-aspect-[205/256] sp-relative">
          <ul class="sp-hidden sp-absolute sp-bottom-6 sp-left-6 md:sp-flex sp-gap-4 [&_li]:sp-rounded-full [&_li]:sp-w-12 [&_li]:sp-h-12 [&_li]:sp-border-2 [&_li]:sp-border-gray-200 [&_li]:sp-bg-white">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
        <div class="sp-flex sp-justify-between">
          <div class="sp-bg-gray-100 sp-h-10 sp-w-96"></div>
          <div class="sp-bg-gray-100 sp-w-10"></div>
        </div>
        <ul class="sp-flex sp-gap-4 [&_li]:sp-w-10 [&_li]:sp-h-10 [&_li]:sp-bg-gray-100 "> 
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <ul class="sp-flex sp-gap-4 [&_li]:sp-rounded-full [&_li]:sp-w-10 [&_li]:sp-h-10 [&_li]:sp-bg-gray-100 md:sp-hidden"> 
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
  `;
  class ProductListing extends HTMLElement {
    constructor() {
      super();
      this.stateKey = 'plpState';
      this.saveStateThrottled = this.throttle(this.saveState.bind(this), 250);
      this.hasStacks = this.dataset.stacks;
      this.pageTitle = this.dataset.title;
      this.stackedTitle = this.dataset.stackedTitle;
    }

    connectedCallback() {
      if (!this.isConnected) return;

      this.restoreState();

      this.addEventListener('click', (e) => {
        const link = e.target.closest('a[href]');
        if (!link) return;

        const productContainer = this.querySelector('[data-product-container]');
        if (productContainer && productContainer.contains(link)) {
          this.saveState();
        }
      });

      window.addEventListener('scroll', () => this.saveScrollOnly(), { passive: true });
      window.addEventListener('popstate', () => {
        this.restoreState();
        this.applyStacksMode(this.classList.contains('has-filters'));
      });

      const productContainer = this.querySelector('[data-product-container]');
      if (productContainer) {
        const mo = new MutationObserver(() => this.saveStateThrottled());
        mo.observe(productContainer, { childList: true, subtree: true });
      }

      ['change', 'click'].forEach((eventType) => {
        window.addEventListener(eventType, e => {
          const actionEl = e.target.closest('[data-filter-action]');
          if (!actionEl) return;

          const productContainer = this.querySelector('[data-product-container]');
          if (!productContainer) return;

          const { filterAction, page } = actionEl.dataset;

          const previousSearchParams = new URLSearchParams(window.location.search);
          let searchParams = new URLSearchParams();

          const activeValues = [...document.querySelectorAll('[data-param-name]')]
            .filter(el =>
              (el.type === 'checkbox' && el.checked) ||
              (el.type === 'number' && el.value.trim() !== '')
            )
            .map(el => ({
              paramName: el.dataset.paramName,
              value: el.value.trim()
            }));

          activeValues.forEach(({ paramName, value }) => {
            if (searchParams.getAll(paramName).includes(value)) return;
            searchParams.append(paramName, value);
          });

          this.classList.toggle('has-filters', activeValues.length > 0);

          ['q', 'sort_by'].forEach(key => {
            if (previousSearchParams.has(key)) {
              searchParams.set(key, previousSearchParams.get(key));
            }
          });

          let newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;

          const injectGrid = () => {
            productContainer.innerHTML = `
              <intersection-loader 
                data-url="${newURL}"
                data-section-id="plp-tiles-listing"
                class="sp-grid sp-grid-cols-2 sm:sp-grid-cols-3 sp-gap-x-1 sp-gap-y-6 md:sp-gap-10 sp-col-span-2 md:sp-col-span-3"
              >${plpLoader.repeat(6)}</intersection-loader>
            `;
            queueMicrotask(() => this.saveState());
          };

          switch (filterAction) {
            case 'update-filters':
              
              injectGrid();
              if (window.matchMedia('(min-width: 768px)').matches) {
                productContainer.scrollIntoView({ behavior: 'smooth' });
              }
              this.updateAppliedFiltersSection(newURL);
              this.applyStacksMode(true);
              break;

            case 'update-filters-banner': {
              const paramName = actionEl.dataset.paramName;
              const value = actionEl.value
              this.querySelectorAll('[data-filter-action="update-filters"], [data-filter-action="update-filters-banner"]').forEach(el => {
                if (el === actionEl) return;
                if (el.matches('input[type="checkbox"], input[type="radio"]')) el.checked = false;
                el.setAttribute('aria-pressed', 'false');
                el.classList.remove('is-active');
              });
              newURL = `${window.location.origin}${window.location.pathname}?${paramName}=${value}`;
              injectGrid();
              if (window.matchMedia('(min-width: 768px)').matches) {
                productContainer.scrollIntoView({ behavior: 'smooth' });
              }
              this.updateAppliedFiltersSection(newURL);
              this.applyStacksMode(true);
              break;
            }

            case 'update-sorting':
              if (actionEl.value === 'none' || searchParams.toString().includes(actionEl.value)) return;
              searchParams.set('sort_by', actionEl.value);
              newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
              injectGrid();
              history.pushState({}, '', newURL);
              this.applyStacksMode(true);
              break;

            case 'remove-filter': {
              const { paramName, value } = actionEl.dataset;
              if (!paramName || !value) return;

              this.querySelectorAll(`[data-param-name="${paramName}"][value="${value}"]`)
                .forEach(el => {
                  if (el.type === 'checkbox') el.checked = false;
                  if (el.type === 'number') el.value = '';
                });

              const remainingValues = [...this.querySelectorAll('[data-param-name]')]
                .filter(el =>
                  (el.type === 'checkbox' && el.checked) ||
                  (el.type === 'number' && el.value.trim() !== '')
                )
                .map(({ value, dataset: { paramName } }) => ({ paramName, value: value.trim() }));

              searchParams = new URLSearchParams();
              remainingValues.forEach(({ paramName, value }) => {
                if (!searchParams.getAll(paramName).includes(value)) {
                  searchParams.append(paramName, value);
                }
              });

              ['q', 'sort_by'].forEach(key => {
                if (previousSearchParams.has(key)) {
                  searchParams.set(key, previousSearchParams.get(key));
                }
              });

              newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
              injectGrid();
              this.updateAppliedFiltersSection(newURL);

              const currentRemoveBtns = this.querySelectorAll('[data-filter-action="remove-filter"]').length;
              const remainingRemoveBtns = Math.max(0, currentRemoveBtns - 1);
              const hasFilters = remainingRemoveBtns > 0;

              this.classList.toggle('has-filters', hasFilters);
              this.applyStacksMode(hasFilters);
              break;
            }

            case 'pagination-next':
              searchParams.set('page', Number(page));
              newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;
              actionEl.closest('[data-pagination-wrapper]')?.remove();
              productContainer.innerHTML += `
                <intersection-loader 
                  data-url="${newURL}"
                  data-section-id="plp-tiles-listing"
                  class="sp-grid sp-grid-cols-2 sm:sp-grid-cols-3 sp-gap-x-1 sp-gap-y-6 md:sp-gap-10 sp-col-span-2 md:sp-col-span-3"
                >${plpLoader.repeat(6)}</intersection-loader>
              `;
              queueMicrotask(() => this.saveState());
              history.replaceState({}, '', newURL);
              this.applyStacksMode(true);
              break;

            default:
              break;
          }
        });
      });

      this.applyStacksMode(this.classList.contains('has-filters'));
    }

    updateAppliedFiltersSection(newURL) {
      const appliedFiltersContainer = this.querySelector('[data-applied-filters]');
      if (!appliedFiltersContainer) return;
      appliedFiltersContainer.innerHTML = `
        <intersection-loader 
          data-url="${newURL}"
          data-section-id="applied-filters"
        >
          <ul class="sp-max-w-screen-xl sp-px-6 sm:sp-px-0 sp-mx-auto sp-flex sp-gap-2 [&_li]:sp-bg-sizeChartGray [&_li]:sp-w-28 [&_li]:sp-h-10 [&_li]:sp-px-4 [&_li]:sp-py-2">
            <li></li><li></li><li></li>
          </ul>
        </intersection-loader>
      `;
      history.pushState({}, '', newURL);
      queueMicrotask(() => this.saveState());
    }

    applyStacksMode(isFiltered) {
      if (!this.hasStacks) return;
      const stacks = this.querySelector('[data-stack-container]');
      const products = this.querySelector('[data-product-container]');
      const title = this.querySelector('[data-listing-title]');
      if (!stacks || !products || !title) return;

      stacks.classList.toggle('sp-hidden', isFiltered);
      products.classList.toggle('sp-hidden', !isFiltered);
      title.textContent = isFiltered ? (this.pageTitle || '') : (this.stackedTitle || '');

      if (!isFiltered) {
        const baseURL = `${window.location.origin}${window.location.pathname}`;
        history.replaceState({}, '', baseURL);
      }
    }


    saveState() {
      const productContainer = this.querySelector('[data-product-container]');
      const appliedFiltersContainer = this.querySelector('[data-applied-filters]');
      if (!productContainer) return;

      const state = {
        url: window.location.href,
        html: productContainer.innerHTML,
        appliedFiltersHTML: appliedFiltersContainer ? appliedFiltersContainer.innerHTML : null,
        hasFilters: this.classList.contains('has-filters'),
        scrollY: window.scrollY,
        ts: Date.now()
      };
      try {
        sessionStorage.setItem(this.stateKey, JSON.stringify(state));
      } catch (_) {
      }
    }

    saveScrollOnly() {
      try {
        const raw = sessionStorage.getItem(this.stateKey);
        if (!raw) return;
        const state = JSON.parse(raw);
        if (state.url !== window.location.href) return;
        state.scrollY = window.scrollY;
        state.ts = Date.now();
        sessionStorage.setItem(this.stateKey, JSON.stringify(state));
      } catch (_) {}
    }

    restoreState() {
      try {
        const raw = sessionStorage.getItem(this.stateKey);
        if (!raw) return false;
        const state = JSON.parse(raw);

        if (state.url !== window.location.href) return false;

        const productContainer = this.querySelector('[data-product-container]');
        if (!productContainer) return false;
        if (Date.now() - (state.ts || 0) > 12 * 60 * 60 * 1000) return false;
        productContainer.innerHTML = state.html || productContainer.innerHTML;
        if (state.hasFilters) this.classList.add('has-filters'); else this.classList.remove('has-filters');
        const appliedFiltersContainer = this.querySelector('[data-applied-filters]');
        if (appliedFiltersContainer && typeof state.appliedFiltersHTML === 'string') {
          appliedFiltersContainer.innerHTML = state.appliedFiltersHTML;
        }
        requestAnimationFrame(() => {
          window.scrollTo(0, state.scrollY || 0);
        });

        this.applyStacksMode(this.classList.contains('has-filters'));
        return true;
      } catch (_) {
        return false;
      }
    }

    throttle(fn, wait) {
      let last = 0, timer = null, ctx, args;
      return function throttled(...a) {
        ctx = this; args = a;
        const now = Date.now();
        const remaining = wait - (now - last);
        if (remaining <= 0) {
          clearTimeout(timer); timer = null; last = now; fn.apply(ctx, args);
        } else if (!timer) {
          timer = setTimeout(() => { last = Date.now(); timer = null; fn.apply(ctx, args); }, remaining);
        }
      };
    }
  }

  customElements.define('product-listing', ProductListing);
}
